const PHONE_CODE = "+213";
const NUMBERS_LIMIT = 9;
const MOBILE_STARS = "xxxxxxxxx";
const MAPS_COUNTRY = "dz";

const ALL = "All";
const DELIVERY = "Delivery";
const PICKUP = "Pickup";

const COUNTRY_NAME = process.env.REACT_APP_COUNTRY_NAME;

const DISCOUNT_COLORS = {
  BRAND_RED: '#d60000',
} as const;

const DISCOUNT_STYLES = {
  AMOUNT: {
    color: DISCOUNT_COLORS.BRAND_RED,
    fontWeight: '600' as const,
  },
} as const;

const COUPON_TYPES = {
  PERCENT: 'percent',
  VALUE: 'value',
  COMBO: 'combo',
  ITEM: 'item',
} as const;

const COUPON_LEVELS = {
  GROUP: 'group',
  CART: 'cart',
} as const;

const ORDER_CHANNELS = {
  ONLINE: 'online',
  ALL: 'all',
} as const;

const TOAST_CONFIG = {
  POSITION: 'top-right',
  HIDE_PROGRESS_BAR: true,
  AUTO_CLOSE: 3000,
} as const;

export const CONSENT_KEYS = ['send_email', 'send_pn', 'send_sms', 'check_policy'] as const;
export type ConsentKey = typeof CONSENT_KEYS[number];

export const CONSENT_LABELS: Record<ConsentKey, string> = {
  send_email: 'Email',
  send_pn: 'Push Notification',
  send_sms: 'SMS',
  check_policy: 'Privacy Policy',
};

export {
  PHONE_CODE,
  NUMBERS_LIMIT,
  MOBILE_STARS,
  ALL,
  DELIVERY,
  PICKUP,
  MAPS_COUNTRY,
  COUNTRY_NAME,
  DISCOUNT_COLORS,
  DISCOUNT_STYLES,
  COUPON_TYPES,
  COUPON_LEVELS,
  ORDER_CHANNELS,
  TOAST_CONFIG,
};

